<template>
  <div>
    <va-card class="overflow-auto">
      <vue-element-loading :active="visible" :is-full-screen="true" />
      <div class="row">
        <div class="flex md6 sm6 xs12">
          <h4 style="font-size: 24px !important">PROFILE DETAILS</h4>
        </div>
      </div>
      <div class="pt-2">
        <div class="row">
          <table class="table table-white flex md10">
            <thead>
              <tr></tr>
            </thead>
            <tbody class="row">
              <tr
                class="col-md-6"
                style="font-style: italic !important"
                v-if="data.userID"
              >
                <th scope="col">Unique ID:</th>
                <td>{{ data.userID }}</td>
              </tr>
              <tr
                class="col-md-6"
                style="font-style: italic !important"
                v-if="data.fullName"
              >
                <th scope="col">Name:</th>
                <td>{{ data.fullName }}</td>
              </tr>
              <tr class="col-md-6" v-if="data.usertype">
                <th scope="col">User Type:</th>
                <td>
                  {{ data.usertype.uname }}
                  <button
                    v-b-modal.modal-footer-sm1
                    type="button"
                    class="btn btn-outline-primary"
                    style="
                      padding-top: 0px !important;
                      padding-bottom: 6px !important;
                      padding-left: 4px !important;
                      padding-right: 6px !important;
                    "
                  >
                    Update
                  </button>
                </td>
                <b-modal
                  id="modal-footer-sm1"
                  title
                  button-size="sm"
                  hide-footer
                >
                  <form @submit="updateUsertype">
                    <div class="form-group">
                      <h5 style="color: black!impoertant; padding-bottom: 20px">
                        Update Status
                      </h5>
                      <select
                        class="pt-2 pb-2"
                        style="width: 100% !important"
                        v-model="usertype"
                      >
                        <option value selected disabled hidden>CITES</option>
                        <option
                          class="text-capitalize"
                          v-for="type in utype"
                          :value="type._id"
                          :key="type._id"
                        >
                          {{ type.uname }}
                        </option>
                      </select>
                    </div>

                    <button class="btn btn-success" type="submit">
                      UPDATE
                    </button>
                  </form>
                </b-modal>
              </tr>
              <tr class="col-md-6" v-if="data.email">
                <th scope="col">Email:</th>
                <td>{{ data.email }}</td>
              </tr>
              <tr class="col-md-6" v-if="data.phone">
                <th scope="col">Mobile:</th>
                <td>{{ data.phone }}</td>
              </tr>
              <tr class="col-md-6" v-if="data.address">
                <th scope="col">Address:</th>
                <td>{{ data.address }}</td>
              </tr>
              <tr class="col-md-6" v-if="data.state">
                <th scope="col">State:</th>
                <td>{{ data.state }}</td>
              </tr>
              <tr class="col-md-6" v-if="data.create_date">
                <th scope="col">Account Created Date:</th>
                <td>{{ data.create_date }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="pt-3" v-if="data.status != 'pending'">
        <router-link
          :to="{
            path: '/singlereportlist',
            query: {
              id: id,
              type: 'user',
            },
          }"
          >Click here to see the crime reported by
          {{ data.fullName }}</router-link
        >
      </div>
    </va-card>
    <va-card class="pb-4" v-if="data.status === 'pending'">
      <div class="row">
        <div class="flex sm6 xs12 md2">
          <b-button variant="success" @click="approve()">Approve</b-button>
        </div>
        <div class="flex sm6 xs12 md2">
          <b-button variant="danger" class="px-4" v-b-modal.modal-footer-sm
            >Reject</b-button
          >
          <b-modal id="modal-footer-sm" title button-size="sm" hide-footer>
            <form @submit="onSubmit">
              <h5>Rejecting the User</h5>
              <div class="form-group pt-3">
                <label for="exampleInputEmail1">Remarks</label>
                <input
                  type="text"
                  class="form-control"
                  id="exampleInputEmail1"
                  v-model="remark"
                  required
                  aria-describedby="emailHelp"
                  placeholder="Remarks"
                />
              </div>
              <button class="btn btn-danger" type="submit">REJECT</button>
            </form>
          </b-modal>
        </div>
      </div>
    </va-card>
    <va-card class="pb-4">
      <div class="row">
        <!-- <div class="flex sm6 xs12 md12">
          <h5>If you felt something wrong about {{ data.fullName }} ?</h5>
        </div> -->
        <div
          v-if="data.status === 'active'"
          class="flex sm6 xs12 md4 "
        >
          <b-button variant="danger" v-b-modal.modal-footer-sm
            >Reject the User</b-button
          >
          <b-modal id="modal-footer-sm" title button-size="sm" hide-footer>
            <form @submit="onSubmit">
              <div class="form-group">
                <label for="exampleInputEmail1">Remarks</label>
                <input
                  type="text"
                  class="form-control"
                  id="exampleInputEmail1"
                  v-model="remark"
                  required
                  aria-describedby="emailHelp"
                  placeholder="Remarks"
                />
              </div>
              <button class="btn btn-danger" type="submit">REJECT</button>
            </form>
          </b-modal>
        </div>
        <div v-if="data.status === 'reject'" class="flex sm6 xs12 md4">
          <b-button variant="success" @click="approve()"
            >Approve the User</b-button
          >

        </div>
        <div class="flex sm6 xs12 md4">
          <b-button variant="danger" @click="deleteUser()"
            >Remove the User</b-button
          >
        </div>
      </div>
      <div class="row px-2" v-if="data.status === 'reject'">
         <h4 class="pt-2" style="font-size: 24px !important; color: red !important">
            <b>Reason for Rejection:&nbsp;&nbsp;</b>
            {{ data.remarks }}
          </h4>
      </div>
    </va-card>
  </div>
</template>

<script>
import axios from 'axios'
import VueElementLoading from 'vue-element-loading'
export default {
  components: {
    VueElementLoading,
  },
  props: ['id'],
  data () {
    return {
      visible: false,
      data: [],
      remark: '',
      utype: [],
      usertype: null,
    }
  },
  mounted: function () {
    this.getData()
    this.userView()
  },
  methods: {
    deleteUser () {
      if (confirm('Are you sure?')) {
        this.visible = true
        axios({
          method: 'POST',

          headers: {
            token: localStorage.getItem('token'),
          },
          url: '/admin/user/delete/' + this.id,
        })
          .then((response) => {
            this.visible = false
            if (response.data.status) {
              this.msg = response.data.msg
              this.$dlg.alert(this.msg, () => {}, { messageType: 'success' })
              this.$router.go(-1)
            } else {
              this.msg = response.data.msg
              this.$dlg.alert(this.msg, () => {}, { messageType: 'error' })
            }
          })
          .catch((err) => {
            this.visible = false
            this.errors.push(err)
            this.$dlg.alert(
              this.msg,
              () => {
                // this.$router.push("/Dashboard");
              },
              { messageType: 'error' }
            )
          })
      } else {
        this.visible = false
        this.$router.go(-1)
      }
    },
    userView () {
      this.visible = true
      axios({
        method: 'GET',
        url: '/usertype/list',
      })
        .then((response) => {
          this.utype = response.data.data
          this.visible = false
        })
        .catch((err) => {
          this.visible = false
          console.log(err)
        })
    },
    getData () {
      this.visible = true
      var url
      if (this.$route.query.type == 'admin') url = '/admin/me'
      else url = '/user/view/'
      axios({
        method: 'POST',
        url: url,
        headers: {
          token: localStorage.getItem('token'),
        },
        data: { id: this.id },
      })
        .then((response) => {
          // console.log(response.data.data)
          if (response.data.status === true) {
            this.data = response.data.data
            this.usertype = this.data.usertype._id
            var dt = this.data.create_date
            dt = new Date(dt)
            dt = dt.toString()
            dt = dt.slice(0, 15)
            this.data.create_date = dt
          } else {
          }
          this.visible = false
        })
        .catch((e) => {
          console.log(e)
          this.visible = false
          this.errors.push(e)
          this.msg = 'failed'
        })
    },
    approve: function (item) {
      this.visible = true
      var data = {}
      data['id'] = this.id
      axios({
        method: 'POST',
        headers: {
          token: localStorage.getItem('token'),
        },
        url: '/user/approve/',
        data: data,
      })
        .then((response) => {
          if (response.data.status) {
            this.$dlg.alert(
              (this.msg = response.data.msg),
              () => {
                this.$router.push('/users/pending')
              },
              { messageType: 'success' }
            )
          } else {
            this.$dlg.alert(
              (this.msg = response.data.msg),
              () => {
                this.$router.push('/users/pending')
              },
              { messageType: 'error' }
            )
          }
        })
        .catch((e) => {
          console.log(e)
          this.visible = true
        })
    },
    updateUsertype (evt) {
      // this.visible = true
      var data1 = {}
      data1['usertype'] = this.usertype
      data1['uid'] = this.id
      evt.preventDefault()
      axios({
        method: 'POST',
        url: '/user/usertype/change',
        data: data1,
        headers: {
          token: localStorage.getItem('token'),
        },
      })
        .then((response) => {
          this.msg = response.data.msg
          // console.log(this.statu)
          if (response.data.status === true) {
            this.visible = false
            this.$bvModal.hide('modal-footer-sm1')
            this.getData()
          } else {
            this.visible = false
            this.$bvModal.hide('modal-footer-sm1')
            this.$bvToast.toast(this.msg, {
              title: `Usertype`,
              solid: true,
              variant: 'danger',
            })
            this.getData()
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    onSubmit (evt) {
      this.visible = true
      var data = {}
      data['id'] = this.id
      data['remark'] = this.remark
      console.log(this.data)
      evt.preventDefault()
      axios({
        method: 'POST',
        url: '/user/reject',
        headers: {
          token: localStorage.getItem('token'),
        },
        data: data,
      })
        .then((response) => {
          // alert('Business was successfully Approved')

          this.visible = true
          if (response.data.status) {
            this.$dlg.alert(
              (this.msg = response.data.msg),
              () => {
                this.$router.push('/users/pending')
              },
              { messageType: 'success' }
            )
            //  this.$bvModal.hide('modal-footer-sm')
          } else {
            this.$dlg.alert(
              (this.msg = response.data.msg),
              () => {
                this.$router.push('/users/pending')
              },
              { messageType: 'error' }
            )
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
  },
}
</script>
<style scoped>
/* .modal-footer {
  display: none !important;
} */
</style>
